import { SUPPORT_MSG } from "@genbaryoku/contract";
import { useState } from "react";
import { Link } from "react-router";
import { useMe } from "../auth.js";
import { BackButton, usePageName } from "../components/BackButton.jsx";
import { Shell } from "../components/Shell.jsx";
import { SupportForm } from "../components/Support.jsx";
import { AuthCard, Help } from "../components/ui.jsx";
import { useProduct } from "../lib/useProduct.js";

/**
 * お問い合わせ（/contact、#124 の 3a、docs/50 §2.1）。ログインの画面・紹介ページ・画面の下の「お問い合わせ」から。
 *   ログイン前＝ログイン前の枠（AuthCard）で メールアドレス・お名前（任意）・種類・内容・画像
 *   ログイン後＝アプリの枠で 種類・内容・画像（会社・人・メールは API が添える。上の帯の「？」と同じ中身）
 *   メールでも受ける（support@）。アドレスはソースにそのまま書かない（SiteFooter と同じ）
 */
export function ContactPage() {
  const me = useMe();
  usePageName(SUPPORT_MSG.title);
  if (me.isPending) return null;
  if (me.data) {
    return (
      <Shell me={me.data}>
        <BackButton />
        <div className="hrow">
          <h1>
            {SUPPORT_MSG.title}
            <Help text={SUPPORT_MSG.hours} label="お問い合わせの説明" />
          </h1>
        </div>
        <div className="supcard">
          <ContactBody guest={false} />
        </div>
      </Shell>
    );
  }
  return (
    <AuthCard title={SUPPORT_MSG.title} help={<Help text={SUPPORT_MSG.hours} label="お問い合わせの説明" />}>
      <ContactBody guest />
    </AuthCard>
  );
}

function ContactBody({ guest }: { guest: boolean }) {
  const [sent, setSent] = useState(false);
  const P = useProduct();
  const mail = P.support.user + String.fromCharCode(64) + P.support.domain;
  if (sent) {
    return (
      <div className="supdone">
        <p role="status" data-testid="support-sent">
          {SUPPORT_MSG.sent}
        </p>
        <div className="supact">
          <button type="button" className="btn" onClick={() => setSent(false)}>
            続けて送信
          </button>
          {guest ? (
            <Link className="btn text" to="/login">
              ログイン
            </Link>
          ) : null}
        </div>
      </div>
    );
  }
  return (
    <SupportForm
      guest={guest}
      onSent={() => setSent(true)}
      footer={({ busy }) => (
        <div className="supact">
          <button type="submit" className="btn primary big" disabled={busy} data-testid="support-send">
            {SUPPORT_MSG.send}
          </button>
          <p className="hint supmail">
            メールでも受け付けます：<a href={"mailto:" + mail}>{mail}</a>
          </p>
        </div>
      )}
    />
  );
}
